import { Host } from '@core/ui';
import { useTranslation } from 'react-i18next';

export const HostName = ({ nameOfHost }: { nameOfHost: string; }) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="flex flex-wrap gap-1.5">
                <Host classNames="w-6 stroke-current" />
                {t('WebinarDetails.Label.Host')}
                <span className="w-full md:text-lg font-medium leading-none">{nameOfHost}</span>
            </div>
        </>
    )
};
